// extracted by mini-css-extract-plugin
export default {"sidebar":"Administrator_sidebar__rGvJG","portal-certificate-box":"Administrator_portal-certificate-box__5RRgk"};